import "../../../node_modules/@chenfengyuan/datepicker/dist/datepicker.esm";

import $ from "jquery";
import Constants from "../business/Constants";
import GigyaManager from "../business/GigyaManager";
import RestManager from "../business/RestManager";
import { SmartComponent } from "smart-component-js";
import moment from "moment";
import productData from "../data/product";
import storeOffline from "../data/store_offline";
import storeOnline from "../data/store_online";

class FormCtrl extends SmartComponent {
  constructor(element, parentComponent, params) {
    super(element, parentComponent, params);

    this.alphanumReg = /^[A-Za-z0-9 ']+$/;
    this.numberReg = /^[0-9]+$/;
    this.centReg = /^[0-9]{2}$/;
    this.files = [];

    this.init();
  }

  init() {
    this.loadChildComponents(this);

    this.startLoader();

    GigyaManager.getLoggedUserCached().then(
      (u) => {
        var ch = u.data[Constants.CH_PROMO];
        if (typeof ch !== "undefined" && ch != null && ch != "") {
          $("#regulationAcceptance").remove();
        }

        this.buildDropdownStore(storeOffline);
        this.buildDropdownProduct();

        var now = new Date().getHours();
        var hStart = 9;
        var hEnd = 21;
        console.log(now);
        if (
          moment(Constants.CLOSING_STEP_1_DATE, "DD/MM/YYYY HH:mm").diff(
            moment()
          ) < 0
        ) {
          let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">Il concorso è terminato!</h2>
                                                            <p>Ricorda, hai tempo fino alle 18.00 del 13 novembre 2020 per richiedere il tuo premio.</p>
                                                            <a href="/promozioni/dona-felicita-a-colazione-finiper/area-personale" class="button">Torna all’area personale</a>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
          $(this.element).append(tmplModalGeneric);
          this.loadChildComponents(this);
          $(".main-form").remove();
          this.removeLoader();
        } else {
          if(now < hStart || now >= hEnd){
            let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">Torna domani!</h2>
                                                            <p>Ricorda, puoi giocare i tuoi scontrini solo dalle 9:00 alle 21:00!</p>
                                                            <a href="/promozioni/dona-felicita-a-colazione-conad/area-personale" class="button">Torna all’area personale</a>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
            $(this.element).append(tmplModalGeneric);
            this.loadChildComponents(this);
            $(".main-form").remove();
            this.removeLoader();
          }else{
            this.removeLoader();
          }
        }
      },
      (err) => {
        window.location.href =
          "/login?urlBack=" +
          window.location.href.replace(window.location.origin, "") +
          "&regSource=" +
          Constants.PROMO_CODE;
      }
    );

    $.fn.datepicker.languages["it-IT"] = {
      format: "dd/mm/yyyy",
      days: [
        "Domenica",
        "Lunedì",
        "Martedì",
        "Mercoledì",
        "Giovedì",
        "Venerdì",
        "Sabato",
      ],
      daysShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
      daysMin: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
      weekStart: 1,
      months: [
        "Gennaio",
        "Febbraio",
        "Marzo",
        "Aprile",
        "Maggio",
        "Giugno",
        "Luglio",
        "Agosto",
        "Settembre",
        "Ottobre",
        "Novembre",
        "Dicembre",
      ],
      monthsShort: [
        "Gen",
        "Feb",
        "Mar",
        "Apr",
        "Mag",
        "Giu",
        "Lug",
        "Ago",
        "Set",
        "Ott",
        "Nov",
        "Dic",
      ],
      autoHide: true,
    };
    $('[data-toggle="datepicker"]').datepicker({
      language: "it-IT",
      format: "dd-mm-yyyy",
      startDate: new Date(2020, 4, 21),
      endDate: new Date(),
    });

    $('input[name="storeType"]').change((e) => {
      let val = $('input[name="storeType"]:checked').val();
      this.buildDropdownStore(val == "offline" ? storeOffline : storeOnline);
    });

    $("#numScontrino").on("input", (e) => {
      const val = e.currentTarget.value;
      const reg = /^[0-9]+$/;
      const isNumber = reg.test(val);
      if (!isNumber) e.currentTarget.value = val.replace(/\D/g, "");
      else e.currentTarget.value = val;
    });

    //IMAGE VIEW
    $("#foto-scontrino").change(() => {
      var input = $("#foto-scontrino")[0];
      let file = input.files[0];
      var maxSize = $(input).data("max-size");

      if (maxSize > file.size) {
        this.startLoader();
        RestManager.uploadImage(this.files.length == 0 ? 1 : 2, file).then(
          (data) => {
            let filename_server = data.response.data.filename;
            let idx_file = filename_server.split(".")[0];
            var reader = new FileReader();
            reader.onload = function (e) {
              if (filename_server.match(/pdf$/)) {
                $(".file-list").append(
                  '<div class="row" id="' +
                    idx_file +
                    '"><div class="figure"><img' +
                    ' src="/fe-web/img/icons/avatar_placeholder.jpg"></div><div' +
                    ' class="file-name">' +
                    file.name +
                    '</div><div class="delete-file" component-click="removeFile(\'' +
                    idx_file +
                    "')\"></div></div>"
                );
              } else {
                $(".file-list").append(
                  '<div class="row" id="' +
                    idx_file +
                    '"><div class="figure"><img src="' +
                    e.target.result +
                    '"></div><div class="file-name">' +
                    file.name +
                    '</div><div class="delete-file" component-click="removeFile(\'' +
                    idx_file +
                    "')\"></div></div>"
                );
              }
            };
            reader.readAsDataURL(file);
            this.files.push(filename_server);
            if (this.files.length == 2) {
              $("#foto-scontrino").prop("disabled", true);
              $(".carica-scontrino").addClass("disabled");
            } else {
              $("#foto-scontrino").prop("disabled", false);
              $(".carica-scontrino").removeClass("disabled");
            }
            $("#foto-scontrino").val("");
            this.removeLoader();
          },
          (resp) => {
            //TODO POPUP ERRORE
            $("#foto-scontrino").prop("disabled", false);
            $(".carica-scontrino").removeClass("disabled");
            $("#foto-scontrino").val("");
            this.removeLoader();
          }
        );
      } else {
        $("#foto-scontrino").addClass("error");
        $(".custom-row--middle").append(
          '<span class="error-feedback"><span' +
            ' class="icon-error">!</span> Il file caricato è troppo grande</span>'
        );
      }
    });

    $("#conferma").on("click", (e) => {
      e.preventDefault();
      this.submitForm();
    });
  }

  buildDropdownStore(stores) {
    let options = '<option value="-" default="true">Scegli lo store</option>';

    let storeList = stores.response.data;
    for (var i = 0; i < storeList.length; i++) {
      options += `<option value="${storeList[i].tag}">${storeList[i].description}</option>`;
    }

    $("#market").html(options);
    $("#market").val("-");
  }

  buildDropdownProduct() {
    let options = "";

    let productList = productData.response.data;
    for (var i = 0; i < productList.length; i++) {
      options += `<option value="${productList[i].code}">${productList[i].description}</option>`;
    }

    $("#product").html(
      '<option value="0" default="true">Scegli il prodotto Numero1</option>' +
        options
    );
    $("#product2").html(
      '<option value="0" default="true">Scegli il prodotto Numero2</option>' +
        options
    );
    $("#product").val(0);
    $("#product2").val(0);
  }

  submitForm() {
    this.startLoader();
    this.validateForm();
  }

  removeFile(idx) {
    $("#" + idx).remove();
    for (let i = 0; i < this.files.length; i++) {
      if (this.files[i].indexOf(idx) != -1) {
        this.files.splice(i, 1);
      }
    }
    if (this.files.length == 2) {
      $("#foto-scontrino").prop("disabled", true);
      $(".carica-scontrino").addClass("disabled");
    } else {
      $("#foto-scontrino").prop("disabled", false);
      $(".carica-scontrino").removeClass("disabled");
    }
  }

  // CHECK VALIDAZIONE
  validateForm() {
    console.log("entrato in validateForm");

    $(".error-feedback").remove();
    $("input, select").removeClass("error");

    var varStore = this.take_market();
    var varReceipt_product_code = this.take_product();
    var varReceipt_product2_code = this.take_product2();
    var varReceipt_date = this.take_data();
    var varReceipt_hour = this.take_hours();
    var varReceipt_minutes = this.take_minutes();
    var varReceipt_number = this.take_numScontrino();
    var varReceipt_amount_euros = this.take_euro();
    var varReceipt_amount_cents = this.take_cent();
    var varAcceptance = this.take_acceptance();

    var varFiles = this.files.length > 0;

    if (!varFiles) {
      $("#foto-scontrino").addClass("error");
      $(".custom-row--middle").append(
        '<span class="error-feedback"><span' +
          ' class="icon-error">!</span> Devi caricare almeno una foto dello scontrino!</span>'
      );

      console.log("entrato in validateForm");
    }

    if (
      varStore &&
      varReceipt_product_code &&
      varReceipt_product2_code &&
      varReceipt_date &&
      varReceipt_hour &&
      varReceipt_minutes &&
      varReceipt_number &&
      varReceipt_amount_euros &&
      varReceipt_amount_cents &&
      varAcceptance &&
      varFiles
    ) {
      console.log("entrato in validateForm - valido");
      this.sendForm();
    } else {
      console.log("entrato in validateForm - non valido");
      this.removeLoader();
      return false;
    }
  }

  removeLoader() {
    $(".tool_loader").fadeOut(500).remove();
    $("body").removeClass("noScroll");
    $("#conferma").prop("disabled", false).removeClass("disabled");
  }

  startLoader() {
    $(".mb-finiper-felicita2020").append(
      '<div data-tool-loader="" class="tool_loader"><svg><use xlink:href="#svg_loader"></use></svg></div>'
    );
    $("body").addClass("noScroll");
    $("#conferma").prop("disabled", true).addClass("disabled");
  }
  //VALIDAZIONE SINGOLI CAMPI
  sendForm() {
    let market = $("#online").prop("checked") ? "iperdrive.it" : "finiper";

    let product = $("#product").val();
    let product2 = $("#product2").val();
    let date = $("#dataCal").val();
    let arrDate = date.split("-");
    let day = arrDate[0];
    let month = arrDate[1];
    let year = arrDate[2];
    let hours = $("#hours").val();
    let minutes = $("#minutes").val();
    let numScontrino = $("#numScontrino").val();
    let euro = $("#euro").val();
    let cent = $("#cent").val();
    let basedata = {
      receipt_product_code: product,
      receipt_day: day,
      receipt_month: month,
      receipt_year: year,
      receipt_minutes: minutes,
      receipt_hour: hours,
      receipt_number: numScontrino,
      receipt_amount_euros: euro,
      receipt_amount_cents: cent,
      receipt_file_front: this.files[0],
    };

    let customdata = {
      store: market,
      products: [
        { code: product, quantity: 1 },
        { code: product2, quantity: 1 },
      ],
    };

    if (this.files.length > 1) {
      basedata["receipt_file_back"] = this.files[1];
    }

    if ($("#acceptance").length == 0) {
      this.doPlayReceiptCall({ basedata, customdata });
    } else {
      GigyaManager.addCH(Constants.CH_PROMO).then(
        (resp) => {
          this.doPlayReceiptCall({ basedata, customdata });
        },
        (err) => {
          console.log(err);
          let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__close" component-click="close()">
                                                            <svg>
                                                                <use xlink:href="#svg_circle_close"></use>
                                                            </svg>
                                                        </div>
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">Ops, qualcosa è andato storto! </h2>
                                                            <p>Ti preghiamo di riprovare più tardi!</p>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
          $(this.element).append(tmplModalGeneric);
          this.loadChildComponents(this);
          this.removeLoader();
        }
      );
    }
  }

  doPlayReceiptCall(scontrino) {
    RestManager.playReceipt(scontrino).then(
      (data) => {
        if (data.response.data.play.status == "WIN") {
          window.location.href =
            "/promozioni/dona-felicita-a-colazione-finiper/hai-vinto?pt=" +
            data.response.data.play.token +
            "&pm=1";
        } else {
          window.location.href =
            "/promozioni/dona-felicita-a-colazione-finiper/non-hai-vinto";
        }
      },
      (data) => {
        this.removeLoader();
        console.log(data);
        let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__close" component-click="close()">
                                                            <svg>
                                                                <use xlink:href="#svg_circle_close"></use>
                                                            </svg>
                                                        </div>
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">Ops, qualcosa è andato storto!</h2>
                                                            <p>${data.status.errors.data.description}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
        $(this.element).append(tmplModalGeneric);
        this.loadChildComponents(this);
      }
    );
  }

  take_market() {
    console.log("entrato in takeMarket");
    if ($("#market").length) {
      var market = $("#market").val();
      if ((market.length < 2) & (market !== undefined)) {
        $("#market").addClass("error");
        $(".row-form--market").append(
          '<span class="error-feedback"><span class="icon-error">!</span> Il campo deve essere selezionato</span>'
        );
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  take_product() {
    if ($("#product").length) {
      var product = $("#product").val();
      if ((product.length < 2) & (product !== undefined)) {
        $("#product").addClass("error");
        $(".row-form--product").append(
          '<span class="error-feedback"><span class="icon-error">!</span> Il campo Prodotto1 deve essere selezionato</span>'
        );
      } else {
        var productArr = productData.response.data.map((o) => o.code);
        if (productArr.indexOf(product) >= 0) {
          return true;
        } else {
          $("#product").addClass("error");
          $(".row-form--product").append(
            '<span class="error-feedback"><span class="icon-error">!</span> Il campo Prodotto1 deve essere selezionato</span>'
          );
        }
      }
    } else {
      return true;
    }
  }

  take_product2() {
    if ($("#product2").length) {
      var product = $("#product2").val();
      if ((product.length < 2) & (product !== undefined)) {
        $("#product").addClass("error");
        $(".row-form--product").append(
          '<span class="error-feedback"><span class="icon-error">!</span> Il campo Prodotto2 deve essere selezionato</span>'
        );
      } else {
        var productArr = productData.response.data.map((o) => o.code);
        if (productArr.indexOf(product) >= 0) {
          return true;
        } else {
          $("#product").addClass("error");
          $(".row-form--product").append(
            '<span class="error-feedback"><span class="icon-error">!</span> Il campo Prodotto2 deve essere selezionato</span>'
          );
        }
      }
    } else {
      return true;
    }
  }

  take_data() {
    if ($("#dataCal").length) {
      var date = $("#dataCal").val();
      if ((date.length < 2) & (date !== undefined)) {
        $("#dataCal").addClass("error");
        $(".row-form--date").append(
          '<span class="error-feedback"><span class="icon-error">!</span> Il campo data deve essere selezionato</span>'
        );
      } else {
        var arrDate = date.split("-");
        var day = arrDate[0];
        var month = arrDate[1];
        var year = arrDate[2];
        //! 20200501
        var startDate = "2020091";
        var endDate = "20201031";
        var selectedDate = year + month + day;
        if (selectedDate >= startDate && selectedDate <= endDate) {
          return true;
        } else {
          $("#dataCal").addClass("error");
          $(".row-form--date").append(
            '<span class="error-feedback"><span class="icon-error">!</span> Attenzione! L\'iniziativa è valida per gli acquisti effettuati dal 01.10.2020 al 30.10.2020</span>'
          );
        }
      }
    } else {
      return true;
    }
  }

  take_hours() {
    if ($("#hours").length) {
      var hours = $("#hours").val();
      if ((hours.length < 2) & (hours !== undefined)) {
        $("#hours").addClass("error");
        $(".row-form--date").append(
          '<span class="error-feedback"><span class="icon-error">!</span> Il campo ore deve essere selezionato</span>'
        );
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  take_minutes() {
    if ($("#minutes").length) {
      var minutes = $("#minutes").val();
      if ((minutes.length < 2) & (minutes !== undefined)) {
        $("#minutes").addClass("error");
        $(".row-form--date").append(
          '<span class="error-feedback"><span class="icon-error">!</span> Il campo minuti deve essere selezionato</span>'
        );
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  take_numScontrino() {
    if ($("#numScontrino").length) {
      var numScontrino = $("#numScontrino").val();
      if ((numScontrino.length < 1) & (numScontrino !== undefined)) {
        $("#numScontrino").addClass("error");
        $(".row-form--scontrino").append(
          '<span class="error-feedback"><span class="icon-error">!</span> Attenzione! Il numero dello scontrino caricato non è corretto</span>'
        );
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  take_euro() {
    if ($("#euro").length) {
      var euro = $("#euro").val();
      if ((euro.length < 1) & (euro !== undefined)) {
        $("#euro").addClass("error");
        $(".row-form--scontrino").append(
          '<span class="error-feedback"><span class="icon-error">!</span>' +
            " Il campo euro deve essere compilato</span>"
        );
      } else {
        var validNum = this.numberReg.test(euro);
        if (!validNum) {
          $("#euro").addClass("error");
          $(".row-form--scontrino").append(
            '<span class="error-feedback"><span class="icon-error">!</span> Attenzione! Il campo euro non è corretto</span>'
          );
        } else {
          return true;
        }
      }
    } else {
      return true;
    }
  }

  take_cent() {
    if ($("#cent").length) {
      var cent = $("#cent").val();
      if ((cent.length < 1) & (cent !== undefined)) {
        $("#cent").addClass("error");
        $(".row-form--scontrino").append(
          '<span class="error-feedback"><span class="icon-error">!</span>' +
            " Il campo centesimi deve essere compilato</span>"
        );
      } else {
        var validCent = this.centReg.test(cent);
        if (!validCent) {
          $("#cent").addClass("error");
          $(".row-form--scontrino").append(
            '<span class="error-feedback"><span class="icon-error">!</span> Il campo centesimi non è corretto, controlla di aver digitato 2 cifre</span>'
          );
        } else {
          return true;
        }
      }
    } else {
      return true;
    }
  }

  take_acceptance() {
    if ($("#acceptance").length) {
      if ($("#acceptance").prop("checked") == false) {
        $("#acceptance").addClass("error");
        $(".custom-row--acceptance").append(
          '<span class="error-feedback"><span class="icon-error">!</span> Attenzione! Devi aver letto e accettato il regolamento.</span>'
        );
      } else {
        return true;
      }
    } else {
      return true;
    }
  }
}

export default FormCtrl;
